import(/* webpackMode: "eager" */ "/codebuild/output/src509251388/src/skop-manage/node_modules/next/dist/client/app-dir/link.js");
